import { usePage } from '@inertiajs/react';
import type { Site } from '@/types';

// The parish identity/branding shared on every page (see Public::SiteSerializer).
export function useSite(): Site {
  return usePage().props.site;
}

// Display helpers with sensible fallbacks for a not-yet-onboarded parish.
export function parishName(site: Site): string {
  return site.officialName ?? 'Portal da Freguesia';
}

export function parishShortName(site: Site): string {
  return site.shortName ?? site.officialName ?? 'Freguesia';
}

export function parishEyebrow(site: Site): string {
  return site.parishType === 'uniao' ? 'União das Freguesias' : 'Freguesia';
}

// Neutral, parish-agnostic fallback — never a specific parish's crest.
const LOGO_PLACEHOLDER = '/parish-logo-placeholder.svg';

export function parishLogo(site: Site): string {
  return site.logoUrl ?? LOGO_PLACEHOLDER;
}

export function parishLogoSmall(site: Site): string {
  return site.logoSmallUrl ?? site.logoUrl ?? LOGO_PLACEHOLDER;
}
